import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-11.651296, 166.948661, 10.8],
  [-11.651199, 166.948628, 10.8],
  [-11.651099, 166.948618, 10.8],
  [-11.650996, 166.948596, 10.8],
  [-11.650887, 166.948596, 10.8],
  [-11.650782, 166.948628, 10.8],
  [-11.650678, 166.948661, 10.8],
  [-11.65058, 166.948714, 10.8],
];

export default stream;
